import React from 'react'

import { LoaderCircleIcon } from 'lucide-react'

import { cn } from '@/lib/utils'

import ChatMessagesList from './ChatMessagesList'
import ScrollToBottomButton from './ScrollToBottomButton'

/**
 * Scrollable chat messages area used inside the Shell layout.
 *
 * This component is intentionally dumb/UI-only: all state and hooks
 * (chat store, scroll behavior, refs, loading state) are owned by Shell
 * and passed in as props so we don't change behavior while refactoring
 * the layout.
 */
const ChatPane = ({
  messages,
  messagesContainerRef,
  showScrollButton,
  scrollToBottom,
  smoothScroll,
  showSpinner,
}) => {
  return (
    <div
      id="chat-container"
      className={cn('relative h-full flex-1', showSpinner && 'opacity-50')}
    >
      {showSpinner && (
        <div className="absolute inset-0 flex animate-pulse items-center justify-center text-foreground">
          <LoaderCircleIcon className="size-40 animate-spin" />
        </div>
      )}
      <div
        ref={messagesContainerRef}
        id="messages-scroll-area"
        className={cn([
          smoothScroll && 'scroll-smooth',
          'flex h-full flex-col overflow-y-auto',
          '@[84rem]/thread:pt-[var(--header-height)]',
          'thread:pt-[var(--header-height)]',
          'overscroll-y-contain',
          'pl-[var(--safe-left)]',
          'pr-[var(--safe-right)]',
          'flex-1',
        ])}
      >
        <div
          aria-hidden="true"
          data-edge="true"
          className="pointer-events-none size-px"
        />
        <div
          id="messages-container"
          className={cn([
            'mt-1.5 flex flex-col pb-24 text-sm',
            '@thread-xl/thread:pt-[var(--header-height)]',
          ])}
        >
          <ChatMessagesList messages={messages} />
          <div>
            <ScrollToBottomButton
              visible={showScrollButton}
              onClick={scrollToBottom}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default ChatPane
